import React from 'react'
import Table from './table'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API } from '@const'
import * as utils from '@utils'
import { Decimal } from 'decimal.js'
import { Grid, Divider, Typography } from '@material-ui/core'

const COMPONENT_GROUP = 'member_search';

class TransferRecordTable extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'TransferRecordTable')
        }
    }

    options = {
        export: false
    }

    componentDidMount() {
        this.props.onRef(this)
        if (utils.checkValid(COMPONENT_GROUP + '.export')) {
            this.options.export = true
        }
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    sumTableColumns = [
        {
            field: 'totalTransferIn',
            type: 'currency',
        },
        {
            field: 'totalTransferOut',
            type: 'currency',
        },
    ]

    columns = [
        {
            field: 'created_at',
            type: 'datetime',
        },
        {
            field: 'record_id',
        },
        {
            field: 'currency',
            translate: {
                dataKey: 'currency',
                tranKey: 'Currency',
            },
        },
        {
            field: 'money',
            type: 'currency',
        },
        {
            field: 'transfer_type',
            translate: {
                dataKey: 'transfer_type',
                tranKey: 'TransferRecordType',
            },
        },
        {
            field: 'status',
            translate: {
                dataKey: 'status',
                tranKey: 'TransferRecordStatus',
            },
        },
        {
            field: 'remark',
        },
        {
            field: 'balance_before',
            type: 'currency',
        },
        {
            field: 'balance_after',
            type: 'currency',
        },
    ]

    SetData(data) {
        this.table.SetData(data, this.props.currency).then(() => {
            this.calculateTotal()
        })
    }

    queryData = (queryParams) => {
        this.sumTable.SetLoading(true)
        this.table.SetLoading(true)

        utils.apiRequest(
            'get',
            API.TRANSFER_RECORD_LIST,
            queryParams,
            (data) => {
                this.table.SetData(data, this.props.currency)
                this.calculateTotal()
            },
            (_err) => {
                this.table.SetData([])
                this.calculateTotal()
            }
        )
    }

    calculateTotal = () => {
        const data = this.table.GetData()
        let totalTransferIn = 0,
            totalTransferOut = 0
        data.forEach((elem) => {
            if (elem['is_success'] === true) {
                switch (elem.transfer_type) {
                    case 'in':
                        totalTransferIn = new Decimal(totalTransferIn).add(elem.money)
                        break
                    case 'out':
                        totalTransferOut = new Decimal(totalTransferOut).add(elem.money)
                        break
                    default:
                }
            }
        })

        this.sumTable
            .SetData(
                [
                    {
                        totalTransferIn: totalTransferIn,
                        totalTransferOut: totalTransferOut,
                    },
                ],
                this.props.currency
            )
            .then(() => {
                this.sumTable.SetLoading(false)
            })
    }

    render() {
        return (
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <Typography variant="h6">{this.t('total')}</Typography>
                    <Table
                        ownerName="TransferRecordTable"
                        columns={this.sumTableColumns}
                        options={{ toolbar: false, paging: false }}
                        onRef={(ref) => (this.sumTable = ref)}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid item xs={12}>
                    <Table ownerName="TransferRecordTable" columns={this.columns} onRef={(ref) => (this.table = ref)} options={{export: this.options.export}} />
                </Grid>
            </Grid>
        )
    }
}

const styles = (_theme) => {
    return {}
}

TransferRecordTable.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    dataService: PropTypes.object,
    currency: PropTypes.string,
}

export default hoc(styles)(TransferRecordTable)
